import { useQuery } from '@tanstack/react-query';
import { projectsApi, MentionableUser } from '@/lib/api';

/**
 * Hook to fetch mentionable users for a project
 */
export function useMentionableUsers(projectId: string | undefined) {
  return useQuery<MentionableUser[]>({
    queryKey: ['mentionable-users', projectId],
    queryFn: () => projectsApi.getMentionableUsers(projectId!),
    enabled: !!projectId,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}


